import { Get } from 'config/apiServiceConfig'

export type GetScanPackageIdResponseType = {
  data: {
    packageId: number
    packageLabel: string
    createdDateTime: number
    inputMethod: Nullable<string>
    rack: Nullable<{
      rackId: number
      rackName: string
      maxTransferQty: number
    }>
  }
}

export const getScanPackageId = (packageLabel: string) =>
  Get<GetScanPackageIdResponseType>({
    url: `/api/package-id/scan`,
    params: {
      packageLabel,
    },
  })
